import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { DiffField } from '../../../../../shared/models/internal/diffs/diff-field';
import { DiffLine } from '../diff-line/diff-line';

@Component({
  selector: 'app-diff-field-viewer',
  imports: [DiffLine],
  templateUrl: './diff-field-viewer.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './diff-field-viewer.scss',
})
export class DiffFieldViewer {
  @Input() public diffField?: DiffField;
}
